module.exports = __webpack_public_path__ + "img/Aktivierung_wide.a86bbe03.jpg";